import React from 'react';
import styles from './Apps.module.css';

interface ExpandBarProps {
    expanded: boolean;
    onToggle: () => void;
    label: string;
}

/** 펼치고 접는 띠. 자리는 GoBar와 같다 */
export const ExpandBar: React.FC<ExpandBarProps> = ({ expanded, onToggle, label }) => (
    <button
        type="button"
        className={`${styles.goBar} ${styles.expandBar}`}
        aria-expanded={expanded}
        onClick={onToggle}
    >
        <span className={styles.goLabel}>{expanded ? '접기' : label}</span>
        <svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true">
            <path d={expanded ? 'M1 6H11' : 'M1 6H11M6 1V11'} fill="none" stroke="currentColor" strokeWidth="1.6" />
        </svg>
    </button>
);

export default ExpandBar;
